import React, { useEffect } from "react";
import HomePageBanner from "../Components/Home/HomePageBanner";
import HomePageService from "../Components/Home/HomePageService";
import HomePageAbout from "../Components/Home/HomePageAbout";
import HomePageForm from "../Components/Home/HomePageForm";
import HomePageWrokProcess from "../Components/Home/HomePageWrokProcess";
import HomePageTeam from "../Components/Home/HomePageTeam";
import HomePageTestimonials from "../Components/Home/HomePageTestimonials";
import HomePageTotals from "../Components/Home/HomePageTotals";
import HomePageBlog from "../Components/Home/HomePageBlog";
import NavBar from "../Components/NavBar"
import Footer from "../Components/Footer"
const HomePageProjectOne = () => {
  useEffect(() =>{
    window.scrollTo({
      top: 0,
      
      behavior: 'smooth'
    });
  })
  return (
    <>
    <NavBar />
      <HomePageBanner />
      <HomePageService />
      <HomePageAbout />
      <HomePageForm />
      <HomePageWrokProcess />
      <HomePageTeam />
      <HomePageTestimonials />
      <HomePageTotals />
      <HomePageBlog />
      <Footer />
    </>
  );
};

export default HomePageProjectOne;
